import getAllMessagesQuery from '../api/query/instantMessages/getAllMessages.graphql'
import getUnreadMessagesQuery from '../api/query/instantMessages/getUnreadMessages.graphql'
import markMessageAsRead from '../api/mutation/instantMessages/markMessageAsRead.graphql'
import markAllMessagesAsRead from '../api/mutation/instantMessages/markAllMessagesAsRead.graphql'

import { gqTools } from '../index'
import gql from 'graphql-tag'

export class InstantMessagesApi {
  static async getAllMessages(types) {
    try {
      const client = await gqTools.getClient('INSTANTMESSAGES')
      return await client.query({
        query: gql`${getAllMessagesQuery}`,
        variables: { types: types }
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async getUnreadMessages(types) {
    try {
      const client = await gqTools.getClient('INSTANTMESSAGES')
      return await client.query({
        query: gql`${getUnreadMessagesQuery}`,
        variables: { types: types }
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async markMessageAsRead(id) {
    try {
      const client = await gqTools.getClient('INSTANTMESSAGES')
      return await client.mutate({
        mutation: gql`${markMessageAsRead}`,
        variables: { id }
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async markAllMessagesAsRead() {
    try {
      const client = await gqTools.getClient('INSTANTMESSAGES')
      return await client.mutate({
        mutation: gql`${markAllMessagesAsRead}`
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }
}
